<video
  class="video-control"
  *ngIf="videoUrl; else youTubeTutor"
  controls
  controlsList="nodownload"
  autoplay
>
  <source [src]="videoUrl" />
</video>
<ng-template #youTubeTutor>
  <app-youtube-embedded [youtubeTutorVideo]="youtubeTutorVideo"></app-youtube-embedded>
</ng-template>
